import { Icon, IconProps } from "./Icon";

export function IconCarPaid(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M21.19 14h-3.75l-1.83-3.65A3.69 3.69 0 0 0 12.17 8H7.36A7.45 7.45 0 0 0 0 14.23V22h3.16A3 3 0 1 0 3 21H1v-6h20.2a1.81 1.81 0 0 1 1.8 1.79V21h-2v1h3v-5.2a2.81 2.81 0 0 0-2.81-2.8ZM6 19a2 2 0 1 1-2 2 2 2 0 0 1 2-2Zm1-5H1.08A6.42 6.42 0 0 1 7 9Zm1 0V9h4.19a2.7 2.7 0 0 1 2.53 1.76l1.6 3.24Zm2 1.99h2v1h-2zM17 18a3 3 0 0 0-3 3h-4v1h4.17A3 3 0 1 0 17 18Zm0 5a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm3-18h2a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-3v1h1.52v1h1V8H22a2 2 0 0 0 2-2 2 2 0 0 0-2-2h-2a.92.92 0 0 1-.69-.26A1 1 0 0 1 19 3a1 1 0 0 1 1-1h3V1h-1.51V0h-1v1H20a2 2 0 0 0-2 2.06 2 2 0 0 0 .57 1.41A2 2 0 0 0 20 5Z" />
    </Icon>
  );
}
